import type { KpiRow } from "@/lib/reporting.api";
import { KpiComparisonChart } from "./KpiComparisonChart";

export function KpiComparisonSection({
  title,
  description,
  label,
  rows,
  color,
}: {
  title: string;
  description: string;
  label: string;
  rows: KpiRow[];
  color: string;
}) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">{title}</p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">{description}</p>
      <KpiComparisonChart label={label} rows={rows} color={color} />
    </div>
  );
}
